import { Injectable } from '@angular/core';
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';
import { environment } from 'src/environments/environment';
import { UserDeviceTokenService } from '../proxy/user-device-tokens/user-device-token.service';

@Injectable({
  providedIn: 'root',
})
export class FirebaseMessagingService {
  private messaging!: Messaging;
  private lastToken: string | null = null;
  private lastRowId: string | null = null;

  constructor(private userDeviceTokenService: UserDeviceTokenService) {
    // ✅ Initialize Firebase only once
    if (!getApps().length) {
      initializeApp(environment.firebase);
    }

    this.messaging = getMessaging();
  }

  async requestAndSaveToken() {
    try {
      console.log('Step 1: Requesting notification permission');

      const permission = await Notification.requestPermission();
      console.log('Notification permission:', permission);

      if (permission !== 'granted') {
        console.warn('Notification permission not granted');
        return;
      }

      console.log('Step 2: Waiting for service worker');

      const registration = await navigator.serviceWorker.ready;
      console.log('Service worker ready:', registration);

      console.log('Step 3: Getting FCM token');

      const token = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapidKey,
        serviceWorkerRegistration: registration,
      });

      console.log('Token response:', token);

      if (token) {
        console.log('token generated: ',token);
        this.lastToken = token;
        this.saveTokenToBackend(token);
        console.log('FCM Token:', token);
      } else {
        console.warn('No FCM token returned');
      }

      this.listenForeground();
    } catch (error) {
      console.error('FCM error:', error);
    }
  }

  private saveTokenToBackend(token: string) {
    const payload = {
      tokens: token,
      device: navigator.platform,
      browser: navigator.userAgent,
    };

    console.log('Saving token payload:', payload);

    this.userDeviceTokenService.create(payload).subscribe({
      next: (res) => {
        console.log('Token saved successfully:', res);
        this.lastToken = res.tokens;
        this.lastRowId = res.id;
      },
      error: (err) => {
        console.error('Error saving token:', err);
      },
    });
  }

  listenForeground() {
    onMessage(this.messaging, (payload) => {
      console.log('Foreground message received:', payload);

      const n = payload.notification;
      if (!n) return;

      new Notification(n.title ?? '', {
        body: n.body ?? '',
        icon: '/assets/img/company-logo.png',
      });
    });
  }
}